import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FlowManagementService } from '../services/flow-management.service';
import { Flow } from '../obj/Flow';
import { MsalHelperService } from '../services/msal-helper.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css'],
    standalone: false
})
export class DashboardComponent implements OnInit {

  @ViewChild('iframe', {static: true}) iframe: ElementRef;

  flow: any = null;
  
  constructor(private flowManagementService: FlowManagementService, private msalHelperService: MsalHelperService) { }

  ngOnInit() {

    this.loadFlow();
  }

  async loadFlow() {

    if (this.flow == null) {
      let flows = await this.flowManagementService.getFlows(this.flowManagementService.currentEnvironment);

      let first = flows[0];  
      this.flow = await this.flowManagementService.getFlow(first.environment, first.flowName).toPromise();  
    }
    
    let proxy = this.iframe.nativeElement.contentWindow.proxy;

    proxy.tenantId = (await this.msalHelperService.getUser()).idToken['tid'];
    proxy.token = 'xyz';

    proxy.InitializeDesignerRequestEvent({
      Options: {
        BaseUrl: window.location.origin,
        ApiVersion: "2016-11-01",
        config: {},
        Location: "x",
        ResourceGroup: "x",
        SubscriptionId: "x",
        TelemetryBaseUrl: window.location.origin,
        TelemetryVersion: "2016-11-01",

        ConnectionApiVersion: "2016-11-01",
        CustomApisApiVersion: "2016-11-01",
        ConnectionGatewaysApiVersion: "2016-11-01",
        ManagedApisApiVersion: "2016-11-01",
        BatchApiVersion: "2016-11-01",
        ApiManagementApiVersion: "2016-11-01",
        ApiOperationsApiVersion: "2016-11-01",
        IntegrationServiceEnvironmentApiVersion: "2016-11-01",
        ArmApiVersion: "2016-11-01",
        WorkflowsApiVersion: "2016-11-01",
        SitesApiVersion: "2016-11-01",
        HideCustomConnectors: true,
      }
    });

    proxy.LoadDesignerRequestEvent({
      FlowContent: JSON.stringify(this.flow.properties),
      Options: {
        SkuName: "Flow"
      },
      TriggerCallbacks: ()=>{

      }
    });

  }

}
